//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import DateString from '@models/DateString';
import TimeZoneId from '@models/TimeZoneId';

/**
 * The eligible pages for the screen capture service. This enum MUST match the
 * `ScreenCaptureReportPage` enum in the curalate-screen-capture-service
 * repo, or the calls to SCS will fail.
 */
export enum SCREEN_CAPTURE_PAGES {
  INSIGHTS_SUMMARY = 'InsightsSummary',
  INSTAGRAM_SUMMARY = 'InstagramSummary',
  INSTAGRAM_SCHEDULE = 'InstagramSchedule',
  INSTAGRAM_FEED_PREVIEW = 'InstagramFeedPreview',
  PERFORMANCE_REPORT = 'PerformanceReport',
  FACEBOOK_SUMMARY = 'FacebookSummary',
  PINTEREST_SUMMARY = 'PinterestSummary',
  TIKTOK_SUMMARY = 'TikTokSummary',
}

export interface IScreenCaptureDateRange {
  startDate: DateString;
  endDate: DateString;
}

export interface IDownloadPdfRequest {
  creatorName: string;
  dateRange?: IScreenCaptureDateRange;
  filename?: string;
  pageName: string;
  timeZone?: TimeZoneId;
  urlParams?: Record<string, unknown>;
}
